/**
 * Created with IntelliJ IDEA.
 * User: livnato
 * Date: 1/8/14
 * Time: 4:05 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
	"use strict";

	var Backbone = require('backbone');

	var PagingModel = Backbone.Model.extend({
		defaults            :{
			currentPageNumber:1,
			totalPagesNumber :-1
		},
		setCurrentPageNumber:function (pageNumber) {
			this.set("currentPageNumber", pageNumber);
		},
		setTotalPagesNumber :function (totalPagesNumber) {
			this.set("totalPagesNumber", totalPagesNumber);
		},
		getCurrentPageNumber:function () {
			return this.get("currentPageNumber");
		},
		getTotalPagesNumber :function () {
			return this.get("totalPagesNumber");
		}
	});

	return PagingModel;
});
